import React from 'react'

export default function Preloader(props) {
    const color = props.color ? props.color : 'pl-green';
    const texto = props.texto ? props.texto : 'AGUARDE O CARREGAMENTO DOS DADOS...';
    return <>
        {props.loaded == true ? null :
            <p>
                <div className='text-left m-l-20 m-t-20' >
                    <div class="preloader">
                        <div className={`spinner-layer ${color}`} >
                            <div className="circle-clipper left">
                                <div className="circle"></div>
                            </div>
                            <div className="circle-clipper right">
                                <div className="circle"></div>
                            </div>
                        </div>
                    </div>
                    <span className='text-muted blink_me' style={{ marginTop: '15px', color: '#', position: 'absolute', marginLeft: '10px' }}> {texto} </span>
                </div>
            </p>
        }

    </>
}

